// extracted by mini-css-extract-plugin
export default {"loader_wrapper":"VirtualNumbers_loader_wrapper__FO2Wa","dangerButton":"VirtualNumbers_dangerButton__TMxCO"};